import { render } from "./invoice-template.vue?vue&type=template&id=54f49872"
import script from "./invoice-template.vue?vue&type=script&lang=js"
export * from "./invoice-template.vue?vue&type=script&lang=js"

import exportComponent from "/Users/user/Projects/Vue/one-invoice/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__